<template>
  <!-- 协议创建及编辑页面 -->
  <div class="main-content" v-loading="loading">
    <!-- 标题 -->
    <div class="text_title left">
      <!-- <span>字典项数据</span> -->
      <span class="back" @click="back">
        <i class="el-icon-back"></i>返回
      </span>
    </div>
    <!-- 表单 -->
    <inject-form id="form" ref="form" :formData="protocolFormData" :formList="protocolFormList" :formRule="protocolFormRules" @change="change" :type="type" ></inject-form>
    <!-- 表格 -->
    <protocol-table id="table" ref="table" :tableData="protocolTableData" :type="type" :isSubIndex="isSubIndex" :protocolType="protocolType" />
    <el-pagination
      layout="total"
      :total="protocolTableData.length"
    />
    <!-- 确认及取消按键 -->
    <right-corner-buttons @confirm="confirm" />
  </div>
</template>

<script>
import { protocolFormList } from '@/data/formList'
import { protocolFormRules } from '@/data/rules'

import InjectForm from '@/components/form/InjectForm.vue'
import ProtocolTable from '@/tables/ProtocolTable.vue'
import RightCornerButtons from '@/components/buttons/RightCornerButtons.vue'

import { viewProtocol, createProtocol, updateProtocol, copyProtocol } from '@/api/protocol/protocol'
import { proValidation } from '@/utils/tableValidation'

export default {
  name: 'ProtocolCreateView',
  components: {
    InjectForm: InjectForm,
    ProtocolTable,
    RightCornerButtons,
  },
  data () {
    return {
      // add: 创建，edit: 编辑
      type: this.$route.query.type || 'add',
      // 协议id
      protocolId: this.$route.query.id,
      // 协议表单列表
      protocolFormList: protocolFormList,
      // 协议表单标准数据，用于初始化表单数据
      protocolFormData: {
        protocolName: '',
        protocolType: '0',
        deviceType: '',
        protocolVersion: ''
      },
      // 协议表单校验规则
      protocolFormRules: protocolFormRules,
      // 协议表格数据
      protocolTableData: [],
      // 重复地址
      duplicateAddresses: [],
      loading: false,
      isSubIndex: false,
      protocolType: '',
      thisCurrentType: '',
    }
  },
  mounted () {
    // 如果是编辑页面，获取协议信息
    // if (this.type === 'edit' || this.type === 'copy') {
    //   this.getProtocolInfo(this.protocolId)
    // }
    // 字典下拉框赋值
    this.$assignDictOptions(this.protocolFormList, { protocolType: 'protocol_type' }, this.selectDictionary)
    this.$assignDictOptions(this.protocolFormList, { deviceType: 'product_type' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        // 当路由切换到此页面时重置数据
        if (to.name === 'ProtocolCreateView') {
          // this.resetFormAndTable()
        }

        // 如果是编辑模式且有ID，获取协议信息
        if (to.query.id && ( to.query.type === 'edit' || this.type === 'copy')) {
          this.protocolId = to.query.id
          this.getProtocolInfo(to.query.id)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 重置表单和表格数据
    resetFormAndTable () {
      // 重置表单数据
      this.protocolFormData = {
        protocolName: '',
        protocolType: '',
        deviceType: '',
        protocolVersion: ''
      }

      // 重置表格数据
      this.protocolTableData = [
        {
          index: 0,
          subIndex: '',
          startAddress: '0000',
          dataName: '',
          dataLength: '',
          dataType: '',
          needMapping: false,
          mappingType: '',
          mappingId: '',
          mappingName: '',
          unit: '',
          decimal: '',
          rangeMin: '',
          rangeMax: '',
          remark: ''
        }
      ]

      // 重置表单验证状态
      if (this.$refs.form && this.$refs.form.resetFields) {
        this.$refs.form.resetFields()
      }

      // 重置表格状态
      if (this.$refs.table && this.$refs.table.resetTable) {
        this.$refs.table.resetTable()
      }
    },

    // 获取协议信息
    async getProtocolInfo (id) {
      this.loading = true
      // 调用接口获取协议信息
      const res = await viewProtocol(id)
      res.data.protocolData.forEach(item => {
        if (item.needMapping === 1) {
          item.needMapping = true
        } else {
          item.needMapping = false
        }
        item.dataType = item.dataType + ''
        item.mappingType = item.mappingType === null ? item.mappingType : item.mappingType + ''
        item.mappingId = item.mappingId + ''
        item.mappingName = item.mappingName + ''
      })
      this.isSubIndex = res.data.protocolType === '1'? true : false
      // 将协议信息赋值给协议表格数据
      this.protocolTableData = res.data.protocolData
      this.protocolType = res.data.protocolType
      this.thisCurrentType = res.data.protocolType
      // 将协议信息赋值给协议表单数据
      const dataKey = Object.keys(res.data)
      for (const key in this.protocolFormData) {
        if (dataKey.includes(key)) {
          this.protocolFormData[key] = res.data[key]
        }
      }
      this.loading = false
    },

    // 点击确认按钮时触发
    async confirm () {
      this.loading = true
      // 校验表单和表格数据
      const vilidation = await this.handleValidation()
      if (!vilidation) {
        this.$message.error('校验失败, 请检查输入内容是否有缺失或错误')
        this.loading = false
        return
      }
      // 校验通过后提交表单和表格数据
      const data = {}
      // 将表单数据和表格数据合并到一个对象中
      Object.assign(data, this.protocolFormData)
      const protocolTableDataCopy = JSON.parse(JSON.stringify(this.protocolTableData))
      protocolTableDataCopy.forEach((item, index) => {
        item.index = index
        // item.dataType = item.dataType.value
        // item.mappingType = item.mappingType.value
        if (item.needMapping) {
          item.needMapping = 1
        } else {
          item.needMapping = 0
          item.mappingType = ''
          item.mappingName = ''
          item.mappingId = ''
        }
      })
      data.protocolData = protocolTableDataCopy
      if (this.type === 'add') {
        this.protocolCreate(data)
      } else if (this.type === 'edit') {
        data.id = this.protocolId
        this.protocolUpdate(data)
      } else if (this.type === 'copy') {
        this.protocolCopy(data)
      }
    },

    // 创建协议
    async protocolCreate (data) {
      const res = await createProtocol(data)
      console.log('res', res)
      if (res.code === 200) {
        this.$message.success('创建成功')
        this.type = 'edit'
        this.$addHandler('/protocol/manage', '协议管理')
      }
      this.loading = false
    },
    // 修改协议
    async protocolUpdate (data) {
      try {
        const res = await updateProtocol(data)
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.$addHandler('/protocol/manage', '协议管理')
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    // 复制协议
    async protocolCopy (data) {
      console.log('data', data)
      data.protocolData.forEach((item) => {
        item.id = undefined
      })
      try {
        const res = await copyProtocol(data)
        if (res.code === 200) {
          this.$message.success('复制成功')
          this.$addHandler('/protocol/manage', '协议管理')
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    // 数据校验
    async handleValidation () {
      let isRight = false
      try {
        isRight = await proValidation(this.$refs.form)
        if (isRight) {
          isRight = await proValidation(this.$refs.table)
        }
      } catch (error) {
        console.error('handleValidation error', error)
      }
      return isRight
    },
    async change (selectItem){
      if(this.type !== 'add'){
        this.protocolType = this.thisCurrentType
      } else {
        this.protocolType = selectItem
      }
      this.isSubIndex = selectItem === '1'? true : false
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

.form .el-input{
  text-align: flex-start;
  --el-input-width: 220px;
}

.form .el-select{
  --el-select-width: 220px;
}
</style>
